// JS components
require('./components/home_slider');

// AlpineJS
require('./alpine/menu');
require('./alpine/prijzen');
require('alpinejs/dist/alpine-ie11.js');
